import { render, staticRenderFns } from "./DonationForm.vue?vue&type=template&id=603483e9&"
import script from "./DonationForm.vue?vue&type=script&lang=ts&"
export * from "./DonationForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports